/* Theme currency converter (layout-and-site-wide.md §14, decisions.md #17). Converts every .money client-side with
   Shopify's rates script (window.Currency) and keeps the choice in localStorage 'currency'. Each price remembers its
   original markup, so switching back to the shop currency is exact. */
(() => {
  const config = window.RoyaltyTheme?.currency;
  if (!config?.show_multiple_currencies) return;
  const sourceCurrency = config.iso_code || config.shop_currency;
  const withCode = config.display_format === 'money_with_currency_format';
  const noDecimals = /no_decimals/.test(config.money_format || '');

  const read = () => {
    try {
      return localStorage.getItem('currency');
    } catch (e) {
      return null;
    }
  };
  const write = (code) => {
    try {
      localStorage.setItem('currency', code);
    } catch (e) {}
  };

  const format = (cents, code) => {
    const text = new Intl.NumberFormat(document.documentElement.lang || undefined, {
      style: 'currency',
      currency: code,
      currencyDisplay: 'narrowSymbol',
    }).format(cents / 100);
    return withCode ? `${text} ${code}` : text;
  };

  const convertAll = (code) => {
    if (!window.Currency?.convert) return;
    document.querySelectorAll('.money').forEach((el) => {
      if (!el.hasAttribute('data-currency-original')) {
        el.setAttribute('data-currency-original', el.innerHTML);
        el.setAttribute(`data-currency-${sourceCurrency}`, el.innerHTML);
      }
      if (el.getAttribute('data-currency') === code) return;
      const cached = el.getAttribute(`data-currency-${code}`);
      if (cached) {
        el.innerHTML = cached;
      } else {
        const digits = el.getAttribute('data-currency-original').replace(/<[^>]*>/g, '').replace(/[^0-9]/g, '');
        if (!digits) return;
        const cents = parseInt(digits, 10) * (noDecimals ? 100 : 1);
        const html = format(Currency.convert(cents, sourceCurrency, code), code);
        el.setAttribute(`data-currency-${code}`, html);
        el.innerHTML = html;
      }
      el.setAttribute('data-currency', code);
    });
    document.querySelectorAll('[data-currency-label]').forEach((label) => label.textContent !== code && (label.textContent = code));
    document.querySelectorAll('[data-currency-item]').forEach((item) => {
      const current = item.dataset.currencyItem === code;
      item.classList.toggle('disclosure-list__item--current', current);
      item.querySelector('button')?.toggleAttribute('aria-current', current);
    });
  };

  let current = read() || config.default_currency || sourceCurrency;
  const start = () => {
    convertAll(current);
    let timer;
    new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(() => convertAll(current), 50);
    }).observe(document.body, { childList: true, subtree: true });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-currency]');
    if (!button || button.tagName !== 'BUTTON') return;
    event.preventDefault();
    current = button.dataset.currency;
    write(current);
    convertAll(current);
    button.closest('disclosure-menu')?.close();
  });

  window.currencyConverter = { convertAll: () => convertAll(current) };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
